import { pushFBEvent } from './common';

export const PLANS = {
    'fl-1-month-intro-franko': {
        name: 'fl-1-month-intro-franko',
        price: 9.99,
        periodPrice: 9.99,
        description: 'one week trial',
        productId: '1 month - $9.99',
        duration: '1 month',
    },
    'fl-1-month-tomato': {
        name: 'fl-1-month-tomato',
        price: 19.96,
        periodPrice: 19.96,
        description: 'one month',
        productId: '1 month - $19.96',
        duration: '1 month',
    },
    'fl-3-month-garlic': {
        name: 'fl-3-month-garlic',
        price: 35.88,
        periodPrice: 35.88,
        description: 'three months',
        productId: '3 months - $35.88',
        duration: '3 months',
    },
    'fl-monthly-free3d-2999': {
        name: 'fl-monthly-free3d-2999',
        price: 29.99,
        periodPrice: 0,
        description: 'three days free trial',
        productId: '1 month - $29.99',
        duration: '1 month',
    },
    'fl-3month-3999': {
        name: 'fl-3month-3999',
        price: 39.99,
        periodPrice: 39.99,
        description: 'three months',
        productId: '3 months - $39.99',
        duration: '3 months',
    },
};

const UPSELL_PRODUCT = {
    name: 'fl-monthly-driver-sos-skovoroda',
    price: 9.99,
    quantity: 1
};

export const setMetrics = (plan, id, isUpsell = false, referer = '', eventId) => {
    const price = PLANS[plan].periodPrice ?? PLANS[plan].price;
    const upsellPrice = UPSELL_PRODUCT.price;

    const setFbData = type => {
        return {
            value: type === 'upsell' ? upsellPrice : price,
            currency: 'USD',
            content_type: type,
            content_name: referer,
            subscription_sid: id,
        }
    };

    const fbData = setFbData('paid_subscription');
    const upsellFbData = setFbData('upsell');

    pushFBEvent(fbData,`${eventId}_purchase`);
    if (isUpsell) pushFBEvent(upsellFbData,`${eventId}_upsell`);
};
